import { render, staticRenderFns } from "./ErrorPage.vue?vue&type=template&id=13f507ad&scoped=true&lang=true&"
import script from "./ErrorPage.vue?vue&type=script&lang=js&"
export * from "./ErrorPage.vue?vue&type=script&lang=js&"
import style0 from "./_errorPage.scss?vue&type=style&index=0&id=13f507ad&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13f507ad",
  null
  
)

export default component.exports